import { render, staticRenderFns } from "./AddAchievementsDialog.vue?vue&type=template&id=3052833d"
import script from "./AddAchievementsDialog.vue?vue&type=script&lang=js"
export * from "./AddAchievementsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports